export const environment = {
  production: true,
  version: '6.2.1',
  build: '.40'
};
